import { createStyles } from '../../../../../../../../../../../../styles/helpers'
import { greyOutline, orangeShop, textGrey } from '../../../../../../../../../../../../styles/const/colors'

export const periodsValidationIcon = {
  width: '20px',
  height: '20px'
}
const useStyles = createStyles({
  periodsInfo: {
    display: 'flex',
    gap: '4px'
  },
  icon: {
    width: '20px',
    height: '20px'
  },
  competingWarningIcon: {
    extend: periodsValidationIcon,
    color: orangeShop
  },
  customDates: {
    extend: periodsValidationIcon,
    color: greyOutline
  },
  noPeriods: {
    padding: '8px',
    fontSize: '12px',
    color: textGrey
  }
})

export default useStyles
